const e = {
  undo: "Desfazer",
  redo: "Refazer",
  confirm: "Confirmar",
  clear: "Limpar",
  more: "mais",
  cancel: "Cancelar",
  update: "Atualizar"
}, a = {
  positiveText: "Confirmar",
  negativeText: "Cancelar"
}, o = {
  placeholder: "Selecione",
  loading: "Carregando"
}, r = {
  clear: "Limpar",
  now: "Agora",
  confirm: "Confirmar",
  selectTime: "Selecionar hora",
  selectDate: "Selecionar data",
  datePlaceholder: "Selecionar data",
  datetimePlaceholder: "Selecionar data e hora",
  monthPlaceholder: "Selecione o Mês",
  yearPlaceholder: "Selecionar ano",
  quarterPlaceholder: "Selecione o Trimestre",
  startDatePlaceholder: "Data de início",
  endDatePlaceholder: "Data de término",
  startDatetimePlaceholder: "Data e hora de início",
  endDatetimePlaceholder: "Data e hora de término",
  startMonthPlaceholder: "Mês de Início",
  endMonthPlaceholder: "Mês de término",
  today: "Hoje"
}, i = {
  checkTableAll: "Selecionar todos na tabela",
  uncheckTableAll: "Desmarcar todos na tabela",
  confirm: "Confirmar",
  clear: "Limpar",
  apply: "Aplicar",
  filters: "Filtros",
  sort: "Ordenar"
}, n = {
  sourceTitle: "Fonte",
  targetTitle: "Destino"
}, t = {
  selectAll: "Selecionar todos",
  unselectAll: "Desmarcar todos",
  clearAll: "Limpar"
}, c = {
  description: "Nenhum dado"
}, l = {
  placeholder: "Selecione"
}, d = {
  placeholder: "Selecionar hora",
  positiveText: "OK",
  negativeText: "Cancelar",
  now: "Agora"
}, s = {
  goto: "Goto",
  selectionSuffix: "página",
  next: "Seguinte",
  previous: "Anterior"
}, m = {
  add: "Adicionar"
}, p = {
  loading: "Carregando"
}, g = {
  placeholder: "Insira"
}, h = {
  placeholder: "Insira"
}, u = {
  create: "Criar"
}, C = {
  title: "Editor de tema",
  clearAllVars: "Limpar todas as variáveis",
  clearSearch: "Limpar pesquisa",
  filterCompName: "Filtrar nome do módulo",
  filterVarName: "Filtrar nome da variável",
  import: "Importar",
  export: "Exportar",
  restore: "Redefinir para o padrão"
}, f = {
  tipPrevious: "Imagem anterior (←)",
  tipNext: "Próxima imagem (→)",
  tipCounterclockwise: "No sentido anti-horário",
  tipClockwise: "Sentido horário",
  tipZoomOut: "Diminuir o zoom",
  tipZoomIn: "Aumentar o zoom",
  tipClose: "Fechar (Esc)",
  tipOriginalSize: "Redimensionar para o tamanho original"
}, P = {
  heading: "Ordenação e filtros",
  sortHeading: "Ordenar por",
  newestFirst: "Mais novo primeiro",
  oldestFirst: "Mais antigo primeiro",
  ascending: "Asc",
  descending: "Desc",
  apply: "Aplicar",
  clear: "Limpar",
  cancel: "Cancelar",
  filters: "Filtros"
}, D = {
  noMatchingFound: "Nenhum resultado correspondente encontrado"
}, S = {
  margin: "Margem",
  padding: "Espaçamento",
  reset: "Redefinir",
  errorMsg: "O valor fornecido é inválido."
}, T = {
  brandColors: "Cores da marca",
  noBrandColors: "Você ainda não adicionou nenhuma cor de marca.",
  getStarted: "Começar",
  add: "Adicionar",
  default: "Padrão"
}, A = {
  addColor: "Adicionar Nova Cor",
  editColor: "Editar cor",
  add: "Adicionar",
  noData: "Você ainda não adicionou nenhuma cor.",
  invalidCode: "Código de cor inválido",
  defaultColor: "Cores Padrão"
}, v = {
  global: e,
  Popconfirm: a,
  Cascader: o,
  DatePicker: r,
  DataTable: i,
  LegacyTransfer: n,
  Transfer: t,
  Empty: c,
  Select: l,
  TimePicker: d,
  Pagination: s,
  DynamicTags: m,
  Log: p,
  Input: g,
  InputNumber: h,
  DynamicInput: u,
  ThemeEditor: C,
  Image: f,
  SortFilter: P,
  IconPicker: D,
  Spacing: S,
  BrandColorPicker: T,
  BrandBoard: A
};
export {
  A as BrandBoard,
  T as BrandColorPicker,
  o as Cascader,
  i as DataTable,
  r as DatePicker,
  u as DynamicInput,
  m as DynamicTags,
  c as Empty,
  D as IconPicker,
  f as Image,
  g as Input,
  h as InputNumber,
  n as LegacyTransfer,
  p as Log,
  s as Pagination,
  a as Popconfirm,
  l as Select,
  P as SortFilter,
  S as Spacing,
  C as ThemeEditor,
  d as TimePicker,
  t as Transfer,
  v as default,
  e as global
};
